import React, { useEffect, useState } from "react";
import calendarIcon from "../../../images/calendar-icon.png";
import clockIcon from "../../../images/clock-icon.png";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { apiWrapper } from "../../../apis/CommonApi";
import * as fireonApi from '../../../apis/FireOnApi';
import { getDate, getTime } from "../../../utils/date";
import PageHeader from "../../PageHeader";

export default function AddFireInspectionScheduleComponent() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  let scheduleInfo = location.state ? location.state.scheduleInfo : null;
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setFormDataProperty("writer", "");
    setFormDataProperty("startDate", "");
    setFormDataProperty("startTime", "");
    setFormDataProperty("endDate", "");
    setFormDataProperty("endTime", "");
    setFormDataProperty("reason", "");
    setFormDataProperty("inspector", "");
    setFormDataProperty("contact", "");

    if (scheduleInfo) {
      setFormDataProperty("writer", scheduleInfo.writer);
      setFormDataProperty("startDate", scheduleInfo.startDate ? getDate(new Date(scheduleInfo.startDate)) : "");
      setFormDataProperty("startTime", scheduleInfo.startDate ? getTime(new Date(scheduleInfo.startDate)) : "");
      setFormDataProperty("endDate", scheduleInfo.endDate ? getDate(new Date(scheduleInfo.endDate)) : "");
      setFormDataProperty("endTime", scheduleInfo.endDate ? getTime(new Date(scheduleInfo.endDate)) : "");
      setFormDataProperty("reason", scheduleInfo.reason);
      setFormDataProperty("inspector", scheduleInfo.inspector);
      setFormDataProperty("contact", scheduleInfo.contact);
    }
  }, []);

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormDataProperty(name, value);
  };

  const handleSave = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = {
          writer: formData.writer,
          startDate: new Date(`${formData.startDate} ${formData.startTime}`),
          endDate: new Date(`${formData.endDate} ${formData.endTime}`),
          reason: formData.reason,
          inspector: formData.inspector,
          contact: formData.contact,
        };

        let result;
        if (scheduleInfo) {
          result = await fireonApi.updateFireFightingInspectionSchedule(scheduleInfo.id, requestBody);
        } else {
          result = await fireonApi.createFireFightingInspectionSchedule(id, requestBody);
        }

        const { status, data } = result;
        alert(`${data}`);

        if (status === true) {
          //성공 시 뒤로가기
          navigate(-1);
        }
      });
    }
  }

  const checkValid = () => {
    return true;
  }

  return (
    <section class="mbSection">
      <PageHeader isBlack={false} title="소방설비점검일정" isUseMenu={false} />
      <form onSubmit={handleSave}>
        <div class="container pb-40">
          {formData && (
            <div class="input-wrap input-join-wrap">
              {/* <div class="input-item">
                <p class="input-title">소방대상물</p>
                <div class="select-wrap">
                  <select>
                    <option value="" selected disabled>
                      소방대상물을 선택해주세요.
                    </option>
                    {dataSource.length > 0 &&
                      dataSource.map((item) => (
                        <option key={item.id} name={id} value={item.id} onChange={onChange}>
                          {item.buildingName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}
              <div class="input-item">
                <p class="input-title">등록자</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="등록자 성함을 입력해주세요."
                    name="writer"
                    value={formData.writer}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">점검시작 일시</p>
                <div class="input-inner-wrap datetime-wrap">
                  <div class="datetime-field">
                    {/* <img src={calendarIcon} class="input-icon" alt="달력" /> */}
                    <input
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      onChange={onChange}
                      required
                    />
                  </div>
                  <div class=" datetime-field time-field">
                    {/* <img src={clockIcon} class="input-icon" alt="시계" /> */}
                    <input
                      type="time"
                      name="startTime"
                      value={formData.startTime}
                      onChange={onChange}
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">예상 점검종료</p>
                <div class="input-inner-wrap datetime-wrap">
                  <div class="datetime-field">
                    {/* <img src={calendarIcon} class="input-icon" alt="달력" /> */}
                    <input
                      type="date"
                      name="endDate"
                      value={formData.endDate}
                      onChange={onChange}
                      required
                    />
                  </div>
                  <div class=" datetime-field time-field">
                    {/* <img src={clockIcon} class="input-icon" alt="시계" /> */}
                    <input
                      type="time"
                      name="endTime"
                      value={formData.endTime}
                      onChange={onChange}
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">점검자</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="점검자 성함을 입력해주세요."
                    name="inspector"
                    value={formData.inspector}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">휴대폰 번호</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="점검자 연락처를 입력해주세요."
                    name="contact"
                    value={formData.contact}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">점검 사유</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="점검 사유를 입력해주세요."
                    name="reason"
                    value={formData.reason}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div class="btmBtnWrap">
          <button type="button" class="btn btn-grey" onClick={() => navigate(-1)}>취소</button>
          <button type="submit" class="btn btn-black">저장</button>
        </div>
      </form>
    </section >
  );
}
